<div class="pdf-container">
  <object
    class="pdf-preview"
    [title]="attachment.filename"
    [data]="attachment.urlDownload | safeUrl"
  ></object>
</div>
